export enum ContactMethod {
  NoneOrNotSpecified = 0,
  HomePhone = 1,
  CellPhone = 2,
  Email = 3
}
